import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { hasFlpAccessToDataProperty } from 'automation-ui-formula-editor/data-sources/utils/hasFlpAccessToDataProperty';
import { getIsRestrictedSensitiveProperty } from 'automation-ui-formula-editor/data-sources/utils/getIsRestrictedSensitiveProperty';
export const dataTypeToIconName = type => {
  switch (type) {
    case 'bool':
      return 'booleanDataType';
    case 'date':
    case 'datetime':
      return 'date';
    case 'empty':
      return 'exclamation';
    case 'enumeration':
      return 'enumerationDataType';
    case 'number':
      return 'numericDataType';
    default:
      return 'textDataType';
  }
};
export const getPropertyIcon = ({
  dataProperty,
  dataSensitivityAllowlist,
  enforceFlp = false,
  requiredPermissionLevel
}) => {
  if (!dataProperty) {
    return undefined;
  }
  const flpDisabled = enforceFlp && !hasFlpAccessToDataProperty(dataProperty, requiredPermissionLevel);
  const disabledSensitiveProperty = getIsRestrictedSensitiveProperty(dataProperty, dataSensitivityAllowlist);
  if (flpDisabled || disabledSensitiveProperty) {
    return 'hide';
  }
  const {
    dataPropertyType,
    metadata
  } = dataProperty;
  switch (dataPropertyType) {
    case DataSourceType.ACTION_OUTPUT:
    case DataSourceType.DATA_FIELDS:
    case DataSourceType.FETCHED_OBJECT:
      return dataTypeToIconName(metadata === null || metadata === void 0 ? void 0 : metadata.typeDefinition.type);
    case DataSourceType.EMPTY:
      return dataTypeToIconName('empty');
    default:
      return dataTypeToIconName();
  }
};